import { Stack, Typography } from '@mui/material';
import React from 'react';
import './styles.css';

const SpeakingAnimation = () =>
{
	return (
		<Stack direction='row' alignItems={'center'} spacing={0.5}>
			{Array.from({ length: 5 }).map((_, ind) => (
				<Stack key={ind}>
					<Typography
						className='lines'
						style={{
							animationDelay : `${ind * 0.3}s`
						}}
					/>
				</Stack>
			))}
		</Stack>
	);
};

export default SpeakingAnimation;